import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {ElementURL, GenericMethod, UrlParams} from '@/core/Types/IRepository';

class BookingServices extends BaseRepository {
  public collection = 'reservations';
  public version = 'v2';

  public getReservations(params: GenericMethod) {
    return this.request({...params, method: 'get'});
  }

  public updateMany(params: GenericMethod) {
    return super.request({...params, url: 'update_many', method: 'post'});
  }

  public async getAll<T = any>(params: UrlParams<T>): Promise<any> {
    return super.request({...params, method: 'get'});
  }

  public async getBy<T = any>(params: ElementURL<T>): Promise<any> {
    return super.request({...params, url: 'get_by', method: 'post'});
  }

  public async insert<T = any>(params: UrlParams<T>): Promise<any> {
    return super.request({...params, method: 'post'});
  }

  public async update<T = any>(params: ElementURL<T>): Promise<any> {
    return super.request({query: params.query, url: params.id, method: 'put'});
  }

  public async deleteBy<T = any>(params: ElementURL<T>): Promise<any> {
    return super.request({url: params.id, method: 'delete'});
  }

  public async batchDelete<T = any>(params: UrlParams<T>): Promise<any> {
    return super.request({...params, url: 'delete_all', method: 'post'});
  }

  public async restoreBy<T = any>(params: ElementURL<T>): Promise<any> {
    return super.request({...params, url: 'restore', method: 'post'});
  }
}

export default new BookingServices(axiosInstance);
